import React, { useState, useEffect, useCallback } from 'react'
import SatsueiDataMediaArea from './shared/SatsueiDataMediaArea'
import { shareService } from '../services/shareService'
import { toast } from 'react-hot-toast'

const ShareMediaArea = ({ 
  objectId, 
  sharePixId, 
  onMediaTypeChange,
  selectedMediaType = 'image'
}) => {
  const [currentImageList, setCurrentImageList] = useState([])
  const [currentMovieList, setCurrentMovieList] = useState([])
  const [isDownloading, setIsDownloading] = useState(false)

  const loadMedia = useCallback(async () => {
    if (!objectId || !sharePixId) return
    
    try {
      if (selectedMediaType === 'image') {
        const imageData = await shareService.getImageList(objectId, true, sharePixId)
        if (imageData.objectDatas && imageData.objectDatas.length > 0) {
          const images = imageData.objectDatas[0].objectImages || []
          setCurrentImageList(images)
        } else {
          setCurrentImageList([])
        }
      } else if (selectedMediaType === 'movie') {
        const movieData = await shareService.getMovieList(objectId, true, sharePixId)
        setCurrentMovieList(movieData.movieList || [])
      }
    } catch (error) {
      console.error('Failed to load media:', error)
    }
  }, [objectId, sharePixId, selectedMediaType])

  useEffect(() => {
    if (objectId && sharePixId) {
      loadMedia()
    }
  }, [objectId, sharePixId, selectedMediaType, loadMedia])

  const handleDownload = async () => {
    if (!objectId || !sharePixId) {
      toast.error('ダウンロードに必要な情報が不足しています')
      return
    }
    
    if (isDownloading) {
      toast.info('ダウンロード中です...')
      return
    }
    
    setIsDownloading(true)
    
    try {
      const date = new Date()
      const timestamp = date.getFullYear() + "-" + 
        (date.getMonth()+1) + "-" + date.getDate() + "-" +
        ('00'+date.getHours()).slice(-2) + ('00'+date.getMinutes()).slice(-2) + ('00'+date.getSeconds()).slice(-2)
      
      const fileName = "撮影データ" + timestamp
      
      // Show loading toast
      toast.loading('ダウンロードを準備中...', { id: 'download' })
      
      // Create download link
      const blob = await shareService.getObjectListDownload(
        null, // satsueiMemoCategoryId - not needed for share
        objectId, 
        true, // isShareFlg
        sharePixId
      )
      
      if (!blob || blob.size === 0) {
        throw new Error('ダウンロードファイルが空です')
      }
      
      // Handle blob download
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = fileName + ".zip"
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
      
      toast.success('ダウンロードが完了しました', { id: 'download' })
    } catch (error) {
      console.error('Download failed:', error)
      toast.error(`ダウンロードに失敗しました: ${error.message || '不明なエラー'}`, { id: 'download' })
    } finally {
      setIsDownloading(false)
    }
  }

  return (
    <SatsueiDataMediaArea
      mode="share"
      service={shareService}
      serviceParams={[true, sharePixId]} // isShareFlg, sharePixId
      selectedMediaType={selectedMediaType}
      onMediaTypeChange={onMediaTypeChange}
      imageList={currentImageList}
      movieList={currentMovieList}
      otherFileList={[]}
      imageFolderList={[]}
      selectedImageFolderId={99}
      onImageFolderChange={() => {}}
      isSelectionMode={false}
      selectedItems={[]}
      onToggleSelectionMode={() => {}}
      onToggleItemSelection={() => {}}
      onSelectAll={() => {}}
      onClearAll={() => {}}
      onSelectionAction={() => {}}
      onImageEdit={() => {}}
      onDownload={handleDownload}
      isDownloading={isDownloading}
      onShare={() => {}}
      onComposite={() => {}}
      getDropZoneProps={() => ({})}
      isDragOver={false}
      objectId={objectId}
      onImageReorder={() => {}}
    />
  )
}

export default ShareMediaArea